module.exports = __webpack_public_path__ + "img/m3.73835e84.jpg";